import React, { SyntheticEvent } from 'react';
import cx from 'classnames';

import { getTailwindColor, scaleImage } from '@trqk/utils';

const iconId = 'done-circle-2';

const originalDimensions = {
    width: 24,
    height: 24,
};

// A variation on: stockholm-icon-set/Code/Done-circle.svg with a white checkmark
export const IconDoneCircle2 = (props: IconProps): JSX.Element => {
    const fillColor = props?.fillColor ?? 'black';
    const fill = getTailwindColor(fillColor);
    const { height, width } = scaleImage(originalDimensions, props);
    const { addClasses, handleClick } = props;
    const classNames = cx(addClasses, 'inline', {
        'cursor-pointer': handleClick,
    });

    return (
        <svg
            aria-labelledby={iconId}
            className={classNames}
            height={height}
            onClick={(e: SyntheticEvent): void => {
                if (handleClick) {
                    handleClick(e);
                }
            }}
            viewBox={`0 0 ${originalDimensions.width} ${originalDimensions.height}`}
            width={width}
            xmlns="http://www.w3.org/2000/svg"
        >
            <title id={iconId}>Check Mark Icon</title>
            <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg">
                <g fill="none" fillRule="evenodd">
                    <path d="M0 0h24v24H0z" />
                    <circle fill={fill} cx="12" cy="12" r="10" />
                    <path
                        d="M16.769 7.818a1 1 0 011.462 1.364l-7 7.5a1 1 0 01-1.382.077l-3.5-3a1 1 0 011.302-1.518l2.772 2.376 6.346-6.8z"
                        fill="#FFF"
                        fillRule="nonzero"
                    />
                </g>
            </svg>
        </svg>
    );
};
